// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*___COLORS___*/
/*___LAYOUT___*/
:root {
  --header-height:75px;
}
@media only screen and (-webkit-max-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (max--moz-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (-o-max-device-pixel-ratio: 2.1/1) and (min-width: 900px), only screen and (max-device-pixel-ratio: 2.1) and (min-width: 900px) {
  :root {
    --header-height:130px;
  }
}

html {
  font-size: 16px;
  font-family: Figtree, Arial, Helvetica, sans-serif;
  scroll-behavior: smooth;
  color: #FFFFFF;
}

body {
  padding: 0;
  outline: 0;
  box-sizing: border-box;
  background-color: #0C0C0C;
  margin: 0 auto;
  overflow-x: hidden;
}

section {
  position: relative;
  width: 100%;
  margin: auto;
  box-sizing: border-box;
}
@media only screen and (-webkit-max-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (max--moz-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (-o-max-device-pixel-ratio: 2.1/1) and (min-width: 900px), only screen and (max-device-pixel-ratio: 2.1) and (min-width: 900px) {
  section {
    width: 95%;
  }
}
@media only screen and (min-width: 536px) and (orientation: portrait) {
  section {
    width: 95%;
  }
}
@media (min-width: 1200px) {
  section {
    width: 85%;
  }
}

ul {
  list-style: none;
  padding: 0;
}

a {
  text-decoration: none;
  color: inherit;
}

p {
  font-size: 20px;
  margin: 0;
}
@media only screen and (-webkit-max-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (max--moz-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (-o-max-device-pixel-ratio: 2.1/1) and (min-width: 900px), only screen and (max-device-pixel-ratio: 2.1) and (min-width: 900px) {
  p {
    font-size: clamp(18px, 1.5vw, 25px);
  }
}

::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-track {
  background-color: transparent;
}

::-webkit-scrollbar-thumb {
  background-clip: padding-box;
  background-color: #008938;
}

/*_____HEADER_____*/
header {
  height: var(--header-height);
  display: flex;
  justify-content: space-between;
  padding: 0 2.5%;
}
@media only screen and (-webkit-max-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (max--moz-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (-o-max-device-pixel-ratio: 2.1/1) and (min-width: 900px), only screen and (max-device-pixel-ratio: 2.1) and (min-width: 900px) {
  header {
    padding: 0 7.5%;
  }
}
@media only screen and (min-width: 536px) and (orientation: portrait) {
  header {
    gap: 2rem;
  }
}
header .logo {
  display: flex;
  align-items: center;
  height: 100%;
}
header .logo a {
  display: block;
  height: 45px;
}
@media only screen and (-webkit-max-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (max--moz-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (-o-max-device-pixel-ratio: 2.1/1) and (min-width: 900px), only screen and (max-device-pixel-ratio: 2.1) and (min-width: 900px) {
  header .logo a {
    height: 100px;
  }
}
header .logo a img {
  height: 100%;
}
header .burger {
  height: 100%;
  width: var(--header-height);
  z-index: 10;
}
header .burger svg {
  stroke: #008938;
  stroke-width: 3px;
}
@media only screen and (-webkit-max-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (max--moz-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (-o-max-device-pixel-ratio: 2.1/1) and (min-width: 900px), only screen and (max-device-pixel-ratio: 2.1) and (min-width: 900px) {
  header .burger {
    display: none;
  }
}

nav {
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  width: 100vw;
  display: flex;
  align-items: center;
  margin-top: var(--header-height);
  background-color: #0C0C0C;
  transform: translateY(-100%);
  z-index: 9;
  transform: translateY(-100%);
}
@media only screen and (-webkit-max-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (max--moz-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (-o-max-device-pixel-ratio: 2.1/1) and (min-width: 900px), only screen and (max-device-pixel-ratio: 2.1) and (min-width: 900px) {
  nav {
    position: static;
    margin-top: 0;
    transform: inherit;
    opacity: 1;
    width: auto;
    padding-right: 2rem;
  }
}
nav ul {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
@media only screen and (-webkit-max-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (max--moz-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (-o-max-device-pixel-ratio: 2.1/1) and (min-width: 900px), only screen and (max-device-pixel-ratio: 2.1) and (min-width: 900px) {
  nav ul {
    flex-direction: row;
  }
}
nav ul li a {
  display: block;
  padding: 1rem 2rem;
  border-radius: 30px;
  letter-spacing: 0.1em;
  white-space: nowrap;
  text-transform: uppercase;
  cursor: pointer;
}
nav ul li a:hover {
  background-color: green;
}

/*HEADING*/
h1 {
  font-weight: 500;
  font-size: clamp(22px, 2.8vw, 108px);
  text-transform: uppercase;
  letter-spacing: 2.5px;
  line-height: 1.3;
  margin: 0;
}
@media only screen and (min-width: 536px) and (orientation: portrait) {
  h1 {
    font-size: clamp(22px, 3vw, 58px);
    line-height: 2.3;
  }
}

h2 {
  position: relative;
  font-size: clamp(25px, 2.5vw, 42px);
  font-weight: normal;
  letter-spacing: 1.5px;
  padding: 0.5rem 0 0.5rem 2.5rem;
  text-transform: uppercase;
  margin: 0;
  margin-bottom: 3rem;
}
h2::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 85px;
  border-radius: 25px;
  background-color: #008938;
  z-index: -1;
}
@media only screen and (-webkit-max-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (max--moz-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (-o-max-device-pixel-ratio: 2.1/1) and (min-width: 900px), only screen and (max-device-pixel-ratio: 2.1) and (min-width: 900px) {
  h2::before {
    width: 9vw;
    border-radius: 30px;
  }
}

h3 {
  font-size: clamp(20px, 1.5vw, 32px);
  font-weight: normal;
  color: #008938;
  margin: 0;
  margin-bottom: 1rem;
}

h4 {
  margin: 0;
  margin-bottom: 0.5rem;
  color: #008938;
  font-size: clamp(16px, 1vw, 30px);
  font-weight: normal;
  white-space: nowrap;
  text-transform: uppercase;
}

h5 {
  margin: 0;
  margin-bottom: clamp(0.5rem, 1vw, 1.5rem);
  font-size: clamp(11px, 0.6vw, 16px);
  font-style: italic;
  font-weight: normal;
  text-transform: uppercase;
}

/*LANDING*/
.landing .veil {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #0C0C0C;
  opacity: 0.3;
  z-index: 1;
}
.landing .landing-img {
  width: 100%;
  height: calc(100vh - var(--header-height));
  object-fit: cover;
  object-position: center;
}
@media only screen and (-webkit-max-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (max--moz-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (-o-max-device-pixel-ratio: 2.1/1) and (min-width: 900px), only screen and (max-device-pixel-ratio: 2.1) and (min-width: 900px) {
  .landing .landing-img {
    clip-path: url("#landing-clip");
    height: calc(94vh - var(--header-height));
  }
}
@media only screen and (min-width: 536px) and (orientation: portrait) {
  .landing .landing-img {
    height: calc(60vh - var(--header-height));
  }
}
.landing *:not(.veil) {
  z-index: 2;
}
.landing h1 {
  position: absolute;
  top: 12%;
  background-color: #0C0C0C;
  padding: 1.5rem;
  width: 80%;
  border-radius: 0px 40px 40px 0px;
}
@media only screen and (-webkit-max-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (max--moz-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (-o-max-device-pixel-ratio: 2.1/1) and (min-width: 900px), only screen and (max-device-pixel-ratio: 2.1) and (min-width: 900px) {
  .landing h1 {
    top: 0.6rem;
    width: auto;
    padding: 0;
    background-color: inherit;
  }
}
.landing span {
  position: absolute;
  top: 80%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  width: 100%;
  text-align: center;
  font-size: clamp(14px, 1.5vw, 25px);
  text-transform: uppercase;
  font-style: italic;
  opacity: 0.8;
}
@media only screen and (-webkit-max-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (max--moz-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (-o-max-device-pixel-ratio: 2.1/1) and (min-width: 900px), only screen and (max-device-pixel-ratio: 2.1) and (min-width: 900px) {
  .landing span {
    top: 90%;
  }
}
.landing .arrow {
  position: absolute;
  top: 85%;
  left: 50%;
  transform: translateX(-50%) rotate(-90deg);
  width: 5.823vw;
  height: 5.823vw;
  padding: 2.833vw;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  border: 2px solid #FFFFFF;
  fill: #FFFFFF;
}
@media only screen and (max-width: 1023px) and (orientation: landscape) {
  .landing .arrow {
    top: 78%;
    width: 1.823vw;
    height: 1.823vw;
    padding: 0.833vw;
  }
}
@media only screen and (-webkit-max-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (max--moz-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (-o-max-device-pixel-ratio: 2.1/1) and (min-width: 900px), only screen and (max-device-pixel-ratio: 2.1) and (min-width: 900px) {
  .landing .arrow {
    top: 81%;
    left: 3%;
    transform: rotate(-90deg);
    width: 1.823vw;
    height: 1.823vw;
    padding: 0.833vw;
    border: 0.26vw solid #FFFFFF;
  }
}
@media only screen and (min-width: 536px) and (orientation: portrait) {
  .landing .arrow {
    width: 2.823vw;
    height: 2.823vw;
    padding: 1.833vw;
  }
}
.landing .linkedin {
  display: none;
}
@media only screen and (-webkit-max-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (max--moz-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (-o-max-device-pixel-ratio: 2.1/1) and (min-width: 900px), only screen and (max-device-pixel-ratio: 2.1) and (min-width: 900px) {
  .landing .linkedin {
    display: block;
    position: absolute;
    top: 86%;
    right: 3%;
    width: 2.344vw;
    height: 2.344vw;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #FFFFFF;
    border-radius: 100px;
    border: 1px solid #FFFFFF;
  }
  .landing .linkedin:hover {
    background-color: transparent;
  }
  .landing .linkedin:hover svg {
    fill: #FFFFFF;
  }
  .landing .linkedin svg {
    fill: #008938;
    height: 50%;
    width: 50%;
  }
}

/*PRESENTATION*/
.presentation {
  display: flex;
  flex-direction: column;
  margin-top: 8rem;
  padding: 0 2.5%;
}
@media only screen and (-webkit-max-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (max--moz-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (-o-max-device-pixel-ratio: 2.1/1) and (min-width: 900px), only screen and (max-device-pixel-ratio: 2.1) and (min-width: 900px) {
  .presentation {
    gap: 5%;
    margin-top: 10rem;
    flex-direction: row;
    padding: 0;
  }
}
.presentation .text {
  flex: 0 0 33%;
  text-align: justify;
}
.presentation .image {
  position: relative;
  flex: 1 1 auto;
  width: 100%;
  margin-top: 3rem;
  align-self: center;
}
@media only screen and (-webkit-max-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (max--moz-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (-o-max-device-pixel-ratio: 2.1/1) and (min-width: 900px), only screen and (max-device-pixel-ratio: 2.1) and (min-width: 900px) {
  .presentation .image {
    margin-top: 0;
  }
}
.presentation .image #map {
  width: 100%;
  height: 100%;
  aspect-ratio: 1.2/1;
  clip-path: url("#map-clip");
}
.presentation .image address {
  z-index: 1;
  position: absolute;
  bottom: 4%;
  left: 66%;
  width: auto;
}
.presentation .image address span {
  font-size: clamp(20px, 2vw, 60px);
  color: #008938;
}
@media only screen and (min-width: 536px) and (orientation: portrait) {
  .presentation .image address span {
    font-size: clamp(32px, 3vw, 40px);
  }
}
.presentation .image address p {
  font-size: clamp(10px, 0.8vw, 20px);
}
@media only screen and (min-width: 536px) and (orientation: portrait) {
  .presentation .image address p {
    font-size: clamp(14px, 0.8vw, 16px);
  }
}

/*DOMAINE*/
.domaine {
  margin-top: 8rem;
}
@media only screen and (-webkit-max-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (max--moz-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (-o-max-device-pixel-ratio: 2.1/1) and (min-width: 900px), only screen and (max-device-pixel-ratio: 2.1) and (min-width: 900px) {
  .domaine {
    margin-top: 10rem;
  }
}
.domaine h2 {
  width: fit-content;
  margin: 0 auto;
  margin-bottom: 5rem;
}
.domaine .grid {
  width: 95%;
  margin: auto;
  display: flex;
  flex-direction: column;
  gap: 2rem;
}
@media only screen and (-webkit-max-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (max--moz-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (-o-max-device-pixel-ratio: 2.1/1) and (min-width: 900px), only screen and (max-device-pixel-ratio: 2.1) and (min-width: 900px) {
  .domaine .grid {
    width: 100%;
    display: grid;
    width: 100%;
    grid-template-columns: repeat(12, calc((95vw - 11rem) / 12));
    grid-template-rows: repeat(12, calc((100vh - 11rem) / 12));
    gap: 1rem;
  }
}
@media only screen and (min-width: 536px) and (orientation: portrait) {
  .domaine .grid {
    grid-template-columns: repeat(12, calc((95vw - 11rem) / 12));
    grid-template-rows: repeat(12, calc((60vh - 11rem) / 12));
  }
}
@media (min-width: 1200px) {
  .domaine .grid {
    grid-template-columns: repeat(12, calc((85vw - 11rem) / 12));
  }
}
.domaine .grid > div {
  position: relative;
  overflow: hidden;
  border-radius: 50px;
  aspect-ratio: 1.33/1;
  animation: fade-in linear forwards;
  animation-timeline: view();
  animation-range-start: cover;
  animation-range-end: 500px;
  opacity: 0;
  transform: scale(0.5);
}
@media only screen and (-webkit-max-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (max--moz-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (-o-max-device-pixel-ratio: 2.1/1) and (min-width: 900px), only screen and (max-device-pixel-ratio: 2.1) and (min-width: 900px) {
  .domaine .grid > div {
    animation: inherit;
    opacity: 1;
    transform: inherit;
    aspect-ratio: inherit;
  }
}
.domaine .grid > div img {
  object-fit: cover;
  width: 100%;
  height: 100%;
  transition: transform 0.5s ease;
}
.domaine .grid > div div {
  position: absolute;
  bottom: 0;
  box-sizing: border-box;
  width: 100%;
  padding: 1rem 1rem 1rem 2rem;
  border-radius: 0 50px 50px 50px;
  background-color: rgba(255, 255, 255, 0.5);
  min-height: 35%;
}
@media only screen and (-webkit-max-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (max--moz-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (-o-max-device-pixel-ratio: 2.1/1) and (min-width: 900px), only screen and (max-device-pixel-ratio: 2.1) and (min-width: 900px) {
  .domaine .grid > div div {
    padding: 1.667vw 4.167vw 1.667vw 1.667vw;
  }
}
.domaine .grid > div div p {
  font-size: clamp(16px, 1vw, 26px);
  color: #0C0C0C;
}
.domaine .grid > div:not(#domaine-manchonnage) {
  cursor: pointer;
}
.domaine .grid > div:not(#domaine-manchonnage):hover img {
  transform: scale(1.2);
  transition: transform 0.5s ease;
}
.domaine .grid > div:nth-child(1) {
  grid-column: 1/7;
  grid-row: 1/7;
}
@media (min-width: 1200px) {
  .domaine .grid > div:nth-child(1) > div {
    width: fit-content;
  }
}
.domaine .grid > div:nth-child(2) {
  grid-column: 7/13;
  grid-row: 1/7;
}
@media (min-width: 1200px) {
  .domaine .grid > div:nth-child(2) > div {
    width: fit-content;
  }
}
.domaine .grid > div:nth-child(3) {
  grid-column: 1/5;
  grid-row: 7/13;
}
.domaine .grid > div:nth-child(4) {
  grid-column: 5/9;
  grid-row: 7/13;
}
.domaine .grid > div:nth-child(5) {
  grid-column: 9/13;
  grid-row: 7/13;
}

.carousels {
  display: none;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 11;
}
.carousels .splide {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  width: 90%;
  height: 70vh;
  overflow: hidden;
}
@media only screen and (-webkit-max-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (max--moz-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (-o-max-device-pixel-ratio: 2.1/1) and (min-width: 900px), only screen and (max-device-pixel-ratio: 2.1) and (min-width: 900px) {
  .carousels .splide {
    width: 80%;
    height: 80vh;
  }
}
.carousels .splide .splide__slide {
  display: flex;
  justify-content: center;
  align-items: center;
}
.carousels .splide img {
  object-fit: cover;
  height: 100%;
}
.carousels .splide .splide__arrow.carousel-arrow {
  background: #008938;
  width: 35px;
  height: 35px;
}
@media only screen and (-webkit-max-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (max--moz-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (-o-max-device-pixel-ratio: 2.1/1) and (min-width: 900px), only screen and (max-device-pixel-ratio: 2.1) and (min-width: 900px) {
  .carousels .splide .splide__arrow.carousel-arrow {
    width: 75px;
    height: 75px;
  }
}
@media only screen and (min-width: 536px) and (orientation: portrait) {
  .carousels .splide .splide__arrow.carousel-arrow {
    width: 65px;
    height: 65px;
  }
}
.carousels .splide .splide__arrow.carousel-arrow svg {
  fill: #FFFFFF;
  width: 50%;
  height: auto;
}
.carousels .splide .splide__arrow.carousel-arrow:active {
  background: white;
}
.carousels .splide .splide__arrow.carousel-arrow:active svg {
  fill: #008938;
}
.carousels .xMark {
  position: absolute;
  top: 3rem;
  right: 1rem;
  width: 38px;
  height: 38px;
  fill: #008938;
  transition: transform 0.25s ease;
  cursor: pointer;
}
@media only screen and (-webkit-max-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (max--moz-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (-o-max-device-pixel-ratio: 2.1/1) and (min-width: 900px), only screen and (max-device-pixel-ratio: 2.1) and (min-width: 900px) {
  .carousels .xMark {
    right: 3rem;
    width: 48px;
    height: 48px;
  }
}
.carousels .xMark:hover {
  transform: scale(1.1);
  transform: transform 0.25s ease;
}

@keyframes fade-in {
  from {
    transform: scale(0.5);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}
/*EQUIPE*/
.equipe {
  display: flex;
  flex-direction: column-reverse;
  margin-top: 3rem;
  padding: 0 2.5%;
  gap: 2.5rem;
}
@media only screen and (-webkit-max-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (max--moz-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (-o-max-device-pixel-ratio: 2.1/1) and (min-width: 900px), only screen and (max-device-pixel-ratio: 2.1) and (min-width: 900px) {
  .equipe {
    gap: 0;
    margin-top: 10rem;
    flex-direction: row;
    padding: 0;
  }
}
.equipe .text {
  flex: 0 0 38%;
}
.equipe .text .persons {
  display: flex;
  flex-flow: row wrap;
  gap: 1.5rem;
  margin-top: 6rem;
}
@media only screen and (-webkit-max-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (max--moz-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (-o-max-device-pixel-ratio: 2.1/1) and (min-width: 900px), only screen and (max-device-pixel-ratio: 2.1) and (min-width: 900px) {
  .equipe .text .persons {
    margin-top: inherit;
    flex-flow: row wrap;
  }
}
.equipe .text .persons .person {
  display: flex;
  align-items: center;
  flex: 1 1 25%;
}
.equipe .text .persons .person img {
  display: none;
  position: relative;
  width: 35%;
  aspect-ratio: 1/1;
  object-fit: cover;
  border-radius: 200px;
  border: 5px solid #FFFFFF;
  z-index: 1;
}
@media only screen and (-webkit-max-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (max--moz-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (-o-max-device-pixel-ratio: 2.1/1) and (min-width: 900px), only screen and (max-device-pixel-ratio: 2.1) and (min-width: 900px) {
  .equipe .text .persons .person img {
    width: 8.594vw;
    height: 8.594vw;
  }
}
.equipe .text .persons .person > div {
  position: relative;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  width: 100%;
  padding: 4.667vw;
  padding-left: 7.667vw;
  background-color: #FFFFFF;
  border-radius: 35px;
  color: #0C0C0C;
  z-index: 0;
  text-align: center;
}
@media only screen and (-webkit-max-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (max--moz-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (-o-max-device-pixel-ratio: 2.1/1) and (min-width: 900px), only screen and (max-device-pixel-ratio: 2.1) and (min-width: 900px) {
  .equipe .text .persons .person > div {
    min-width: 275px;
    padding: 1.667vw 2.333vw;
    border-radius: 50px;
    text-align: initial;
  }
}
.equipe .text .persons .person > div a {
  font-size: clamp(12px, 0.8vw, 18px);
  line-height: 1.6;
}
.equipe .text .persons .person > div a:hover {
  color: #008938;
}
.equipe .image {
  position: relative;
  flex: 1 1 auto;
  margin-top: 3rem;
  align-self: center;
}
@media only screen and (-webkit-max-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (max--moz-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (-o-max-device-pixel-ratio: 2.1/1) and (min-width: 900px), only screen and (max-device-pixel-ratio: 2.1) and (min-width: 900px) {
  .equipe .image {
    margin-top: 0;
    margin-right: 2.5%;
  }
}
.equipe .image img {
  width: 100%;
  height: 100%;
  clip-path: url("#equipe-clip");
}
.equipe .image div {
  z-index: 1;
  position: absolute;
  bottom: 5%;
  left: 5%;
  width: 35%;
}
@media only screen and (-webkit-max-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (max--moz-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (-o-max-device-pixel-ratio: 2.1/1) and (min-width: 900px), only screen and (max-device-pixel-ratio: 2.1) and (min-width: 900px) {
  .equipe .image div {
    width: 20ch;
    bottom: 9%;
  }
}
.equipe .image div span {
  font-size: clamp(25px, 3vw, 40px);
  color: #008938;
}
.equipe .image div p {
  font-size: clamp(12px, 1vw, 20px);
  margin-top: 0.5vw;
}

/*FOOTER*/
footer {
  position: relative;
  display: flex;
  flex-flow: column nowrap;
  align-items: flex-end;
  width: 100%;
  height: auto;
  margin: auto;
  margin-top: 10rem;
}
@media only screen and (-webkit-max-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (max--moz-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (-o-max-device-pixel-ratio: 2.1/1) and (min-width: 900px), only screen and (max-device-pixel-ratio: 2.1) and (min-width: 900px) {
  footer {
    flex-flow: row nowrap;
    width: 85%;
    height: 21vw;
  }
}
@media only screen and (-webkit-max-device-pixel-ratio: 2.1) and (min-width: 900px) and (min-width: 536px) and (orientation: portrait), only screen and (max--moz-device-pixel-ratio: 2.1) and (min-width: 900px) and (min-width: 536px) and (orientation: portrait), only screen and (-o-max-device-pixel-ratio: 2.1/1) and (min-width: 900px) and (min-width: 536px) and (orientation: portrait), only screen and (max-device-pixel-ratio: 2.1) and (min-width: 900px) and (min-width: 536px) and (orientation: portrait) {
  footer {
    width: 95%;
    height: 23.883vh;
  }
}
footer .clip {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #FFFFFF;
  border-radius: 80px 80px 0 0;
  z-index: -1;
}
@media only screen and (-webkit-max-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (max--moz-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (-o-max-device-pixel-ratio: 2.1/1) and (min-width: 900px), only screen and (max-device-pixel-ratio: 2.1) and (min-width: 900px) {
  footer .clip {
    border-radius: 0;
    clip-path: url("#footer-clip");
  }
}
footer .content {
  display: flex;
  flex-flow: column wrap;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  color: #0C0C0C;
}
@media only screen and (-webkit-max-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (max--moz-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (-o-max-device-pixel-ratio: 2.1/1) and (min-width: 900px), only screen and (max-device-pixel-ratio: 2.1) and (min-width: 900px) {
  footer .content {
    flex-flow: row wrap;
    padding: 0 8rem;
    height: 68%;
  }
}
@media only screen and (min-width: 536px) and (orientation: portrait) {
  footer .content {
    padding: 0 2rem;
  }
}
footer .content .contact-info {
  display: flex;
  flex-flow: column wrap;
  width: 90%;
  align-items: baseline;
  padding: 4rem 0;
  gap: 3rem;
}
@media only screen and (-webkit-max-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (max--moz-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (-o-max-device-pixel-ratio: 2.1/1) and (min-width: 900px), only screen and (max-device-pixel-ratio: 2.1) and (min-width: 900px) {
  footer .content .contact-info {
    flex-flow: row wrap;
    width: 55%;
    height: 58%;
    padding: 0;
    gap: inherit;
  }
}
footer .content .contact-info .social-network {
  width: 90%;
  margin: auto;
}
@media only screen and (-webkit-max-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (max--moz-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (-o-max-device-pixel-ratio: 2.1/1) and (min-width: 900px), only screen and (max-device-pixel-ratio: 2.1) and (min-width: 900px) {
  footer .content .contact-info .social-network {
    width: auto;
    margin: inherit;
  }
}
footer .content .contact-info .social-network .linkedin {
  display: block;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #008938;
  border-radius: 100px;
  border: 1px solid #008938;
}
@media only screen and (-webkit-max-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (max--moz-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (-o-max-device-pixel-ratio: 2.1/1) and (min-width: 900px), only screen and (max-device-pixel-ratio: 2.1) and (min-width: 900px) {
  footer .content .contact-info .social-network .linkedin {
    width: 2.344vw;
    height: 2.344vw;
  }
}
footer .content .contact-info .social-network .linkedin:hover {
  background-color: transparent;
}
footer .content .contact-info .social-network .linkedin:hover svg {
  fill: #008938;
}
footer .content .contact-info .social-network .linkedin svg {
  fill: #FFFFFF;
  height: 50%;
  width: 50%;
}
footer .content h4 {
  text-transform: uppercase;
  color: #0C0C0C;
  margin-bottom: 1rem;
}
footer .content address {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  width: 90%;
  margin: auto;
  gap: 0.5rem;
  font-style: normal;
}
@media only screen and (-webkit-max-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (max--moz-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (-o-max-device-pixel-ratio: 2.1/1) and (min-width: 900px), only screen and (max-device-pixel-ratio: 2.1) and (min-width: 900px) {
  footer .content address {
    width: 60%;
  }
}
footer .content address a {
  font-size: clamp(12px, 0.8vw, 18px);
  position: relative;
  width: 100%;
  padding-left: 2rem;
  margin-bottom: 1rem;
  line-height: 1.4;
}
footer .content address a:hover {
  color: #008938;
}
footer .content address svg {
  position: absolute;
  top: 50%;
  transform: translateY(-50%) translateX(-2rem);
  fill: #008938;
}
footer h2 {
  width: max-content;
  margin: 3rem auto;
  text-align: center;
  color: #0C0C0C;
}
@media only screen and (-webkit-max-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (max--moz-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (-o-max-device-pixel-ratio: 2.1/1) and (min-width: 900px), only screen and (max-device-pixel-ratio: 2.1) and (min-width: 900px) {
  footer h2 {
    position: absolute;
    top: 1.667vw;
    left: 6.5vw;
    margin: 0;
    color: #FFFFFF;
  }
}
@media only screen and (min-width: 536px) and (orientation: portrait) {
  footer h2 {
    top: 1.067vw;
    left: 2.5vw;
  }
}
footer .logo {
  height: 32vw;
  max-height: 145px;
}
@media only screen and (-webkit-max-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (max--moz-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (-o-max-device-pixel-ratio: 2.1/1) and (min-width: 900px), only screen and (max-device-pixel-ratio: 2.1) and (min-width: 900px) {
  footer .logo {
    height: 7.552vw;
  }
}

.real {
  width: 100%;
  padding: 2rem 0;
}
.real p {
  text-align: center;
  font-size: 14px;
}
.real p a:hover {
  color: #008938;
}`, "",{"version":3,"sources":["webpack://./src/style/tools/variables.scss","webpack://./src/style/style.scss","webpack://./src/style/tools/breakdown.scss"],"names":[],"mappings":"AACA,eAAA;AAYA,eAAA;AAKA;EACI,oBAAA;ACfJ;ACaI;EFCJ;IAGQ,qBAAA;ECbN;AACF;;ADgBA;EACI,eAAA;EACA,kDAAA;EACA,uBAAA;EACA,cApBI;ACOR;;ADgBA;EACI,UAAA;EACA,UAAA;EACA,sBAAA;EACA,yBA9BI;EA+BJ,cAAA;EACA,kBAAA;ACbJ;;ADgBA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;ACbJ;ACfI;EFwBJ;IAMQ,UAAA;ECXN;AACF;ACcE;EFVF;IASQ,UAAA;ECTN;AACF;ACdE;EFaF;IAYQ,UAAA;ECPN;AACF;;ADUA;EACI,gBAAA;EACA,UAAA;ACPJ;;ADUA;EACI,qBAAA;EACA,cAAA;ACPJ;;ADUA;EACI,eAAA;EACA,SAAA;ACPJ;AC7CI;EFkDJ;IAIQ,mCAAA;ECLN;AACF;;ADUA;EACI,WAAA;ACPJ;;ADUA;EACI,6BAAA;ACPJ;;ADUA;EACI,4BAAA;EACA,yBA7EI;ACsER;;AA7EA,mBAAA;AAEA;EACI,4BAAA;EACA,aAAA;EACA,8BAAA;EACA,eAAA;AA+EJ;ACvEI;EDZJ;IAMQ,eAAA;EAiFN;AACF;AC1CE;ED9CF;IASQ,SAAA;EAmFN;AACF;AAlFI;EACI,aAAA;EACA,mBAAA;EACA,YAAA;AAoFR;AAnFQ;EACI,cAAA;EACA,YAAA;AAqFZ;AC1FI;EDGI;IAIQ,aAAA;EAuFd;AACF;AAtFY;EACI,YAAA;AAwFhB;AApFI;EACI,YAAA;EACA,2BAAA;EACA,WAAA;AAsFR;AArFQ;EACI,eD1BJ;EC2BI,iBAAA;AAuFZ;AC3GI;EDcA;IASQ,aAAA;EAwFV;AACF;;AAnFA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,gCAAA;EACA,yBDjDI;ECkDJ,4BAAA;EACA,UAAA;EACA,4BAAA;AAsFJ;AC/HI;ED6BJ;IAcQ,gBAAA;IACA,aAAA;IACA,kBAAA;IACA,UAAA;IACA,WAAA;IACA,mBAAA;EAwFN;AACF;AAvFI;EACI,aAAA;EACA,sBAAA;EAIA,SAAA;AAsFR;AC9II;EDkDA;IAIQ,mBAAA;EA4FV;AACF;AAzFY;EACI,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;AA2FhB;AA1FgB;EACI,uBAAA;AA4FpB;;AArFA,UAAA;AAEA;EACI,gBAAA;EACA,oCAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;EACA,SAAA;AAuFJ;ACvIE;ED0CF;IAQQ,iCAAA;IACA,gBAAA;EAyFN;AACF;;AAtFA;EACI,kBAAA;EACA,mCAAA;EACA,mBAAA;EACA,qBAAA;EACA,+BAAA;EACA,yBAAA;EACA,SAAA;EACA,mBAAA;AAyFJ;AAxFI;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,yBDjHA;ECkHA,WAAA;AA0FR;ACrMI;EDkGA;IAWQ,UAAA;IACA,mBAAA;EA4FV;AACF;;AAxFA;EACI,mCAAA;EACA,mBAAA;EACA,cD7HI;EC8HJ,SAAA;EACA,mBAAA;AA2FJ;;AAxFA;EACI,SAAA;EACA,qBAAA;EACA,cDrII;ECsIJ,iCAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;AA2FJ;;AAxFA;EACI,SAAA;EACA,yCAAA;EACA,mCAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;AA2FJ;;AAxFA,UAAA;AAGI;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,mBDlKA;ECmKA,YAAA;EACA,UAAA;AAyFR;AAvFI;EACI,WAAA;EACA,0CAAA;EACA,iBAAA;EACA,uBAAA;AAyFR;ACxPI;ED2JA;IAMQ,+BAAA;IACA,yCAAA;EA2FV;AACF;AC5NE;EDyHE;IAUQ,yCAAA;EA6FV;AACF;AA3FI;EACI,UAAA;AA6FR;AA3FI;EACI,kBAAA;EACA,QAAA;EACA,yBDzLA;EC0LA,eAAA;EACA,UAAA;EACA,gCAAA;AA6FR;AC9QI;ED2KA;IAQQ,WAAA;IACA,WAAA;IACA,UAAA;IACA,yBAAA;EA+FV;AACF;AA7FI;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,4CAAA;EACA,WAAA;EACA,kBAAA;EACA,mCAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;AA+FR;AClSI;EDyLA;IAYQ,QAAA;EAiGV;AACF;AA/FI;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,0CAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,yBAAA;EACA,aD7NA;AC8TR;AC1RE;ED4KE;IAeQ,QAAA;IACA,cAAA;IACA,eAAA;IACA,gBAAA;EAmGV;AACF;AC9TI;EDwMA;IAqBQ,QAAA;IACA,QAAA;IACA,yBAAA;IACA,cAAA;IACA,eAAA;IACA,gBAAA;IACA,4BAAA;EAqGV;AACF;ACvSE;EDsKE;IA8BQ,cAAA;IACA,eAAA;IACA,gBAAA;EAuGV;AACF;AArGI;EACI,aAAA;AAuGR;ACnVI;ED2OA;IAGQ,cAAA;IACA,kBAAA;IACA,QAAA;IACA,SAAA;IACA,cAAA;IACA,eAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,yBD/PJ;ICgQI,oBAAA;IACA,yBAAA;EAyGV;EAxGU;IACI,6BAAA;EA0Gd;EAzGc;IACI,aDrQZ;ECgXN;EAxGU;IACI,aDxQR;ICyQQ,WAAA;IACA,UAAA;EA0Gd;AACF;;AAnGA,eAAA;AAEA;EACI,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,eAAA;AAqGJ;ACtXI;ED6QJ;IAMQ,OAAA;IACA,iBAAA;IACA,mBAAA;IACA,UAAA;EAuGN;AACF;AAtGI;EACI,aAAA;EACA,mBAAA;AAwGR;AArGI;EACI,kBAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AAuGR;ACzYI;ED6RA;IAOQ,aAAA;EAyGV;AACF;AAxGQ;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,2BAAA;AA0GZ;AAxGQ;EACI,UAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;AA0GZ;AAzGY;EACI,iCAAA;EACA,cD3TR;ACsaR;AC7XE;EDgRU;IAIQ,iCAAA;EA6GlB;AACF;AA1GY;EACI,mCAAA;AA4GhB;ACrYE;EDwRU;IAGQ,mCAAA;EA8GlB;AACF;;AAxGA,UAAA;AAEA;EACI,gBAAA;AA0GJ;ACjbI;EDsUJ;IAGQ,iBAAA;EA4GN;AACF;AA3GI;EACI,kBAAA;EACA,cAAA;EACA,mBAAA;AA6GR;AA3GI;EACI,UAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AA6GR;AClcI;EDgVA;IAQQ,WAAA;IACA,aAAA;IACA,WAAA;IACA,4DAAA;IACA,0DAAA;IACA,SAAA;EA8GV;AACF;AC1aE;ED8SE;IAgBQ,4DAAA;IACA,yDAAA;EAgHV;AACF;ACvcE;EDqUE;IAoBQ,4DAAA;EAkHV;AACF;AAjHQ;EACI,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kCAAA;EACA,0BAAA;EACA,4BAAA;EACA,0BAAA;EACA,UAAA;EACA,qBAAA;AAmHZ;ACneI;EDsWI;IAYQ,kBAAA;IACA,UAAA;IACA,kBAAA;IACA,qBAAA;EAqHd;AACF;AApHY;EACI,iBAAA;EACA,WAAA;EACA,YAAA;EACA,+BAAA;AAsHhB;AApHY;EACI,kBAAA;EACA,SAAA;EACA,sBAAA;EACA,WAAA;EACA,4BAAA;EACA,+BAAA;EACA,0CAAA;EACA,eAAA;AAsHhB;AC3fI;ED6XQ;IAUQ,wCAAA;EAwHlB;AACF;AAvHgB;EACI,iCAAA;EACA,cDtZZ;AC+gBR;AArHQ;EACI,eAAA;AAuHZ;AAtHY;EACI,qBAAA;EACA,+BAAA;AAwHhB;AArHQ;EACI,gBAAA;EACA,aAAA;AAuHZ;ACpgBE;ED+Yc;IACI,kBAAA;EAwHlB;AACF;AArHQ;EACI,iBAAA;EACA,aAAA;AAuHZ;AC7gBE;EDwZc;IACI,kBAAA;EAwHlB;AACF;AArHQ;EACI,gBAAA;EACA,cAAA;AAuHZ;AArHQ;EACI,gBAAA;EACA,cAAA;AAuHZ;AArHQ;EACI,iBAAA;EACA,cAAA;AAuHZ;;AAlHA;EACI,aAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;EACA,4CAAA;EACA,YAAA;EACA,aAAA;EACA,oCAAA;EACA,WAAA;AAqHJ;AApHI;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,4CAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;AAsHR;AC9jBI;EDicA;IASQ,UAAA;IACA,YAAA;EAwHV;AACF;AAtHQ;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AAwHZ;AAtHQ;EACI,iBAAA;EACA,YAAA;AAwHZ;AAtHQ;EACI,mBD/dJ;ECgeI,WAAA;EACA,YAAA;AAwHZ;ACllBI;EDudI;IAKQ,WAAA;IACA,YAAA;EA0Hd;AACF;ACtjBE;EDqbM;IASQ,WAAA;IACA,YAAA;EA4Hd;AACF;AA3HY;EACI,aD5eR;EC6eQ,UAAA;EACA,YAAA;AA6HhB;AA3HY;EACI,iBAAA;AA6HhB;AA5HgB;EACI,aDlfZ;ACgnBR;AAzHI;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,aD7fA;EC8fA,gCAAA;EACA,eAAA;AA2HR;ACnnBI;EDgfA;IAUQ,WAAA;IACA,WAAA;IACA,YAAA;EA6HV;AACF;AA5HQ;EACI,qBAAA;EACA,+BAAA;AA8HZ;;AAzHA;EACI;IAAK,qBAAA;IAAuB,UAAA;EA8H9B;EA7HE;IAAG,mBAAA;IAAqB,UAAA;EAiI1B;AACF;AA/HA,SAAA;AAEA;EACI,aAAA;EACA,8BAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;AAgIJ;ACjpBI;ED4gBJ;IAOQ,MAAA;IACA,iBAAA;IACA,mBAAA;IACA,UAAA;EAkIN;AACF;AAjII;EACI,aAAA;AAmIR;AAlIQ;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;AAoIZ;AClqBI;ED0hBI;IAMQ,mBAAA;IACA,mBAAA;EAsId;AACF;AArIY;EACI,aAAA;EACA,mBAAA;EACA,aAAA;AAuIhB;AApIgB;EACI,aAAA;EACA,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,iBAAA;EACA,oBAAA;EACA,yBAAA;EACA,UAAA;AAsIpB;ACvrBI;EDyiBY;IAUQ,cAAA;IACA,eAAA;EAwItB;AACF;AAtIgB;EACI,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBDvkBZ;ECwkBY,mBAAA;EACA,cD5kBZ;EC6kBY,UAAA;EACA,kBAAA;AAwIpB;AC3sBI;EDujBY;IAcQ,gBAAA;IACA,wBAAA;IACA,mBAAA;IACA,mBAAA;EA0ItB;AACF;AAzIoB;EACI,mCAAA;EACA,gBAAA;AA2IxB;AA1IwB;EACI,cDrlBpB;ACiuBR;AArII;EACI,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AAuIR;AChuBI;EDqlBA;IAMQ,aAAA;IACA,kBAAA;EAyIV;AACF;AAxIQ;EACI,WAAA;EACA,YAAA;EACA,8BAAA;AA0IZ;AAxIQ;EACI,UAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,UAAA;AA0IZ;AClvBI;EDmmBI;IAOQ,WAAA;IACA,UAAA;EA4Id;AACF;AA3IY;EACI,iCAAA;EACA,cDtnBR;ACmwBR;AA3IY;EACI,iCAAA;EACA,iBAAA;AA6IhB;;AAvIA,SAAA;AAEA;EACI,kBAAA;EACA,aAAA;EACA,wBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;AAyIJ;AC5wBI;ED2nBJ;IAUQ,qBAAA;IACA,UAAA;IACA,YAAA;EA2IN;AACF;ACjvBE;EDylBF;IAcY,UAAA;IACA,gBAAA;EA8IV;AACF;AA5II;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,yBD3pBA;EC4pBA,4BAAA;EACA,WAAA;AA8IR;ACnyBI;ED6oBA;IAUQ,gBAAA;IACA,8BAAA;EAgJV;AACF;AA9II;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,cD5qBA;AC4zBR;ACjzBI;ED2pBA;IAQQ,mBAAA;IACA,eAAA;IACA,WAAA;EAkJV;AACF;ACtxBE;EDynBE;IAaQ,eAAA;EAoJV;AACF;AAnJQ;EACI,aAAA;EACA,sBAAA;EACA,UAAA;EACA,qBAAA;EACA,eAAA;EACA,SAAA;AAqJZ;ACr0BI;ED0qBI;IAQQ,mBAAA;IACA,UAAA;IACA,WAAA;IACA,UAAA;IACA,YAAA;EAuJd;AACF;AAtJY;EACI,UAAA;EACA,YAAA;AAwJhB;ACl1BI;EDwrBQ;IAIQ,WAAA;IACA,eAAA;EA0JlB;AACF;AAzJgB;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBD7sBZ;EC8sBY,oBAAA;EACA,yBAAA;AA2JpB;ACn2BI;ED+rBY;IAWQ,cAAA;IACA,eAAA;EA6JtB;AACF;AA5JoB;EACI,6BAAA;AA8JxB;AA7JwB;EACI,aDvtBpB;ACs3BR;AA5JoB;EACI,aD5tBhB;EC6tBgB,WAAA;EACA,UAAA;AA8JxB;AAzJQ;EACI,yBAAA;EACA,cDxuBJ;ECyuBI,mBAAA;AA2JZ;AAzJQ;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;AA2JZ;ACl4BI;EDguBI;IASQ,UAAA;EA6Jd;AACF;AA5JY;EACI,mCAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AA8JhB;AA7JgB;EACI,cD1vBZ;ACy5BR;AA5JY;EACI,kBAAA;EACA,QAAA;EACA,6CAAA;EACA,aDjwBR;AC+5BR;AA1JI;EACI,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cD7wBA;ACy6BR;AC95BI;ED8vBA;IAMQ,kBAAA;IACA,YAAA;IACA,WAAA;IACA,SAAA;IACA,cDhxBJ;EC86BN;AACF;ACr4BE;ED4tBE;IAaQ,YAAA;IACA,WAAA;EAgKV;AACF;AA9JI;EACI,YAAA;EACA,iBAAA;AAgKR;ACj7BI;ED+wBA;IAIQ,eAAA;EAkKV;AACF;;AA9JA;EACI,WAAA;EACA,eAAA;AAiKJ;AAhKI;EACI,kBAAA;EACA,eAAA;AAkKR;AAjKQ;EACI,cDtyBJ;ACy8BR","sourcesContent":["@import \"./breakdown.scss\";\r\n/*___COLORS___*/\r\n\r\n$blue: #005EB8;\r\n$red: #FF0000;\r\n$red-hover: #ff6767;\r\n$black: #0C0C0C;\r\n$grey: #A2A2A2;\r\n$light-grey: #F1F1F1;\r\n$white: #FFFFFF;\r\n$green: #008938;\r\n$orange: #ff9500;\r\n\r\n/*___LAYOUT___*/\r\n\r\n$shadow:rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;\r\n$big-border:50px;\r\n\r\n:root{\r\n    --header-height:75px;\r\n    @include tablet{\r\n        --header-height:130px;\r\n    }\r\n}\r\n\r\nhtml{\r\n    font-size: 16px;\r\n    font-family: Figtree, Arial, Helvetica, sans-serif;\r\n    scroll-behavior: smooth;\r\n    color: $white;\r\n}\r\n\r\nbody{\r\n    padding: 0;\r\n    outline: 0;\r\n    box-sizing: border-box;\r\n    background-color: $black;\r\n    margin: 0 auto;\r\n    overflow-x: hidden;\r\n}\r\n\r\nsection{\r\n    position: relative;\r\n    width: 100%;\r\n    margin: auto;\r\n    box-sizing: border-box;\r\n    @include tablet{\r\n        width: 95%;\r\n    }\r\n    @include tablet-portrait{\r\n        width: 95%;\r\n    }\r\n    @include computer{\r\n        width: 85%;\r\n    }\r\n}\r\n\r\nul{\r\n    list-style: none;\r\n    padding: 0;\r\n}\r\n\r\na{\r\n    text-decoration: none;\r\n    color: inherit;\r\n}\r\n\r\np{\r\n    font-size: 20px;\r\n    margin: 0;\r\n    @include tablet{\r\n        font-size: clamp(18px, 1.5vw, 25px);\r\n    }\r\n}\r\n\r\n//----------SCROLL BAR-----------------//\r\n\r\n::-webkit-scrollbar {\r\n    width: 10px;\r\n}\r\n\r\n::-webkit-scrollbar-track {\r\n    background-color: transparent;\r\n}\r\n\r\n::-webkit-scrollbar-thumb {\r\n    background-clip: padding-box;\r\n    background-color: $green;\r\n}\r\n","@import \"./tools/includes.scss\";\r\n\r\n\r\n/*_____HEADER_____*/\r\n\r\nheader{\r\n    height: var(--header-height);\r\n    display: flex;\r\n    justify-content: space-between;\r\n    padding: 0 2.5%;\r\n    @include tablet{\r\n        padding: 0 7.5%;\r\n    }\r\n    @include tablet-portrait{\r\n        gap: 2rem;\r\n    }\r\n    & .logo{\r\n        display: flex;\r\n        align-items: center;\r\n        height: 100%;\r\n        & a{\r\n            display: block;\r\n            height: 45px;\r\n            @include tablet{\r\n                height: 100px;\r\n            }\r\n            & img{\r\n                height: 100%;\r\n            }\r\n        }\r\n    }\r\n    & .burger{\r\n        height: 100%;\r\n        width: var(--header-height);\r\n        z-index: 10;\r\n        & svg{\r\n            stroke: $green;\r\n            stroke-width: 3px;\r\n        }\r\n        @include tablet{\r\n            display: none;\r\n        }\r\n    }\r\n}\r\n\r\n\r\nnav{\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    opacity: 0;\r\n    width: 100vw;\r\n    display: flex;\r\n    align-items: center;\r\n    margin-top: var(--header-height);\r\n    background-color: $black;\r\n    transform: translateY(-100%);\r\n    z-index: 9;\r\n    transform: translateY(-100%);\r\n    @include tablet{\r\n        position: static;\r\n        margin-top: 0;\r\n        transform: inherit;\r\n        opacity: 1;    \r\n        width: auto;\r\n        padding-right: 2rem;\r\n    }\r\n    & ul{\r\n        display: flex;\r\n        flex-direction: column;\r\n        @include tablet{\r\n            flex-direction: row;\r\n        }\r\n        gap: 1rem;\r\n        & li{\r\n            & a{\r\n                display: block;\r\n                padding: 1rem 2rem;\r\n                border-radius: 30px;\r\n                letter-spacing: 0.1em;\r\n                white-space: nowrap;\r\n                text-transform: uppercase;\r\n                cursor: pointer;\r\n                &:hover{\r\n                    background-color: green;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n/*HEADING*/\r\n\r\nh1{\r\n    font-weight: 500;\r\n    font-size: clamp(22px, 2.8vw, 108px);\r\n    text-transform: uppercase;\r\n    letter-spacing: 2.5px;\r\n    line-height: 1.3;\r\n    margin: 0;\r\n    @include tablet-portrait{\r\n        font-size: clamp(22px, 3vw, 58px);\r\n        line-height: 2.3;\r\n    }\r\n}\r\n\r\nh2{\r\n    position: relative;\r\n    font-size: clamp(25px, 2.5vw, 42px);\r\n    font-weight: normal;\r\n    letter-spacing: 1.5px;\r\n    padding: 0.5rem 0 0.5rem 2.5rem;\r\n    text-transform: uppercase;\r\n    margin: 0;\r\n    margin-bottom: 3rem;\r\n    &::before{\r\n        content: \"\";\r\n        position: absolute;\r\n        top: 0;\r\n        left: 0;\r\n        height: 100%;\r\n        width: 85px;\r\n        border-radius: 25px;\r\n        background-color: $green;\r\n        z-index: -1;\r\n        @include tablet{\r\n            width: 9vw;\r\n            border-radius: 30px;\r\n        }\r\n    }\r\n}\r\n\r\nh3{\r\n    font-size: clamp(20px, 1.5vw, 32px);\r\n    font-weight: normal;\r\n    color: $green;\r\n    margin: 0;\r\n    margin-bottom: 1rem;\r\n}\r\n\r\nh4{\r\n    margin: 0;\r\n    margin-bottom: 0.5rem;\r\n    color: $green;\r\n    font-size: clamp(16px, 1vw, 30px);\r\n    font-weight: normal;\r\n    white-space: nowrap;\r\n    text-transform: uppercase;\r\n}\r\n\r\nh5{\r\n    margin: 0;\r\n    margin-bottom: clamp(0.5rem, 1vw, 1.5rem);\r\n    font-size: clamp(11px, 0.6vw, 16px);\r\n    font-style: italic;\r\n    font-weight: normal;\r\n    text-transform: uppercase;\r\n}\r\n\r\n/*LANDING*/\r\n\r\n.landing{\r\n    & .veil{\r\n        position:absolute;\r\n        top: 0;\r\n        left: 0;\r\n        width: 100%;\r\n        height: 100%;\r\n        background: $black;\r\n        opacity: 0.3;  \r\n        z-index: 1;    \r\n    }\r\n    & .landing-img{\r\n        width: 100%;\r\n        height: calc(100vh - var(--header-height));\r\n        object-fit: cover;\r\n        object-position: center;\r\n        @include tablet{\r\n            clip-path: url(\"#landing-clip\") ;\r\n            height: calc(94vh - var(--header-height));\r\n        }\r\n        @include tablet-portrait{\r\n            height: calc(60vh - var(--header-height));\r\n        }\r\n    }\r\n    & *:not(.veil){\r\n        z-index: 2;    \r\n    }\r\n    & h1{\r\n        position: absolute;\r\n        top: 12%;\r\n        background-color: $black;\r\n        padding: 1.5rem;\r\n        width: 80%;\r\n        border-radius: 0px 40px 40px 0px;\r\n        @include tablet{\r\n            top: 0.6rem;\r\n            width: auto;\r\n            padding: 0;\r\n            background-color: inherit;\r\n        }   \r\n    }\r\n    & span{\r\n        position:absolute;\r\n        top: 80%;\r\n        left: 50%;\r\n        transform: translateX(-50%) translateY(-50%);\r\n        width: 100%;\r\n        text-align: center;\r\n        font-size: clamp(14px, 1.5vw, 25px);\r\n        text-transform: uppercase;\r\n        font-style: italic;\r\n        opacity: 0.8;\r\n        @include tablet{\r\n            top: 90%;\r\n        }\r\n    }\r\n    & .arrow{\r\n        position:absolute;\r\n        top: 85%;\r\n        left: 50%;\r\n        transform: translateX(-50%)rotate(-90deg);\r\n        width: 5.823vw;\r\n        height: 5.823vw;\r\n        padding: 2.833vw;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        border-radius: 100px;\r\n        border: 2px solid $white;\r\n        fill: $white;\r\n        @include smartphone-landscape{\r\n            top: 78%;\r\n            width: 1.823vw;\r\n            height: 1.823vw;\r\n            padding: 0.833vw;    \r\n        }\r\n        @include tablet{\r\n            top: 81%;\r\n            left: 3%;\r\n            transform: rotate(-90deg);    \r\n            width: 1.823vw;\r\n            height: 1.823vw;\r\n            padding: 0.833vw;\r\n            border: 0.260vw solid $white;\r\n        }\r\n        @include tablet-portrait{\r\n            width: 2.823vw;\r\n            height: 2.823vw;\r\n            padding: 1.833vw;    \r\n        }\r\n    }\r\n    & .linkedin{\r\n        display: none;\r\n        @include tablet{\r\n            display: block;\r\n            position:absolute;\r\n            top: 86%;\r\n            right: 3%;\r\n            width: 2.344vw;\r\n            height: 2.344vw;\r\n            display: flex;\r\n            align-items: center;\r\n            justify-content: center;\r\n            background-color: $white;\r\n            border-radius: 100px;\r\n            border: 1px solid $white;\r\n            &:hover{\r\n                background-color: transparent;\r\n                & svg{\r\n                    fill: $white;\r\n                }\r\n            }\r\n            & svg{\r\n                fill: $green;\r\n                height: 50%;\r\n                width: 50%;\r\n            }\r\n\r\n        }\r\n    }\r\n\r\n}\r\n\r\n/*PRESENTATION*/\r\n\r\n.presentation{\r\n    display: flex;\r\n    flex-direction: column;\r\n    margin-top: 8rem;\r\n    padding: 0 2.5%;\r\n    @include tablet{\r\n        gap: 5%;\r\n        margin-top: 10rem;\r\n        flex-direction: row;\r\n        padding: 0;\r\n    }\r\n    & .text{\r\n        flex: 0 0 33%;\r\n        text-align: justify;\r\n\r\n    }\r\n    & .image{\r\n        position: relative;\r\n        flex: 1 1 auto;\r\n        width: 100%;\r\n        margin-top: 3rem;\r\n        align-self: center;\r\n        @include tablet{\r\n            margin-top: 0;\r\n        }\r\n        & #map{    \r\n            width: 100%;\r\n            height: 100%;\r\n            aspect-ratio: 1.2/1;\r\n            clip-path: url(\"#map-clip\") ;\r\n        }\r\n        & address{\r\n            z-index: 1;\r\n            position: absolute;\r\n            bottom: 4%;\r\n            left: 66%;\r\n            width: auto;\r\n            & span{\r\n                font-size: clamp(20px, 2vw, 60px);\r\n                color: $green;\r\n                @include tablet-portrait{\r\n                    font-size: clamp(32px, 3vw, 40px);\r\n\r\n                }\r\n            }\r\n            & p{\r\n                font-size: clamp(10px, 0.8vw, 20px);\r\n                @include tablet-portrait{\r\n                    font-size: clamp(14px, 0.8vw, 16px);\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n/*DOMAINE*/\r\n\r\n.domaine{\r\n    margin-top: 8rem;\r\n    @include tablet{\r\n        margin-top: 10rem;\r\n    }\r\n    & h2{\r\n        width: fit-content;\r\n        margin: 0 auto;\r\n        margin-bottom: 5rem;\r\n    }\r\n    & .grid{\r\n        width: 95%;\r\n        margin: auto;\r\n        display: flex;\r\n        flex-direction: column;\r\n        gap: 2rem;\r\n        $gap:1rem;\r\n        @include tablet{\r\n            width: 100%;\r\n            display: grid;\r\n            width: 100%;\r\n            grid-template-columns: repeat(12, calc(((95vw - $gap * 11) / 12)));\r\n            grid-template-rows: repeat(12, calc((100vh - $gap * 11)/12));\r\n            gap: 1rem;\r\n        }\r\n        @include tablet-portrait{\r\n            grid-template-columns: repeat(12, calc(((95vw - $gap * 11) / 12)));\r\n            grid-template-rows: repeat(12, calc((60vh - $gap * 11)/12));\r\n        }\r\n        @include computer{\r\n            grid-template-columns: repeat(12, calc(((85vw - $gap * 11) / 12)));\r\n        }\r\n        &>div{\r\n            position: relative;\r\n            overflow: hidden;\r\n            border-radius: 50px;\r\n            aspect-ratio: 1.33/1;\r\n            animation: fade-in linear forwards;\r\n            animation-timeline: view();\r\n            animation-range-start: cover;\r\n            animation-range-end: 500px;\r\n            opacity: 0;\r\n            transform: scale(0.5);\r\n            @include tablet{\r\n                animation: inherit;\r\n                opacity: 1;\r\n                transform: inherit;\r\n                aspect-ratio: inherit;\r\n            }\r\n            & img{\r\n                object-fit: cover;\r\n                width: 100%;\r\n                height: 100%;\r\n                transition: transform 0.5s ease;\r\n            }\r\n            & div{\r\n                position: absolute;\r\n                bottom: 0;\r\n                box-sizing: border-box;\r\n                width: 100%;\r\n                padding: 1rem 1rem 1rem 2rem;\r\n                border-radius: 0 50px 50px 50px;\r\n                background-color: rgba(255,255,255,0.5);\r\n                min-height: 35%;\r\n                @include tablet{\r\n                    padding: 1.667vw 4.167vw 1.667vw 1.667vw;\r\n                }\r\n                & p{\r\n                    font-size: clamp(16px, 1vw, 26px);\r\n                    color: $black;\r\n                }\r\n            }\r\n        }\r\n        &>div:not(#domaine-manchonnage){\r\n            cursor: pointer;\r\n            &:hover img{\r\n                transform: scale(1.2);\r\n                transition: transform 0.5s ease;\r\n            }\r\n        }\r\n        &>div:nth-child(1){\r\n            grid-column: 1/7 ;\r\n            grid-row: 1/7;\r\n            @include computer{\r\n                &>div{\r\n                    width: fit-content;\r\n                }\r\n            }\r\n        }\r\n        &>div:nth-child(2){\r\n            grid-column: 7/13;\r\n            grid-row: 1/7;\r\n            @include computer{\r\n                &>div{\r\n                    width: fit-content;\r\n                }\r\n            }\r\n        }\r\n        &>div:nth-child(3){\r\n            grid-column:1/5 ;\r\n            grid-row:7/13 ;\r\n        }\r\n        &>div:nth-child(4){\r\n            grid-column:5/9 ;\r\n            grid-row:7/13 ;\r\n        }\r\n        &>div:nth-child(5){\r\n            grid-column:9/13 ;\r\n            grid-row:7/13 ;\r\n        }\r\n    }\r\n}\r\n\r\n.carousels{\r\n    display: none;\r\n    position:fixed;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translateX(-50%) translateY(-50%);\r\n    width: 100vw;\r\n    height: 100vh;\r\n    background-color: rgba(0,0,0,0.8);\r\n    z-index: 11;\r\n    & .splide{\r\n        position:absolute;\r\n        top: 50%;\r\n        left: 50%;\r\n        transform: translateX(-50%) translateY(-50%);\r\n        width: 90%;\r\n        height: 70vh;\r\n        overflow: hidden;\r\n        @include tablet{\r\n            width: 80%;\r\n            height: 80vh;\r\n            \r\n        }\r\n        & .splide__slide{\r\n            display:flex;\r\n            justify-content:center;\r\n            align-items:center;\r\n        }\r\n        & img{\r\n            object-fit: cover;\r\n            height: 100%;\r\n        }\r\n        & .splide__arrow.carousel-arrow{\r\n            background: $green;\r\n            width: 35px;\r\n            height: 35px;\r\n            @include tablet{\r\n                width: 75px;\r\n                height: 75px;\r\n            }\r\n            @include tablet-portrait{\r\n                width: 65px;\r\n                height: 65px;\r\n            }\r\n            & svg{\r\n                fill: $white;\r\n                width: 50%;\r\n                height: auto;\r\n            }\r\n            &:active{\r\n                background: white;\r\n                & svg{\r\n                    fill: $green;\r\n                }\r\n            }\r\n        }\r\n    }\r\n    & .xMark{\r\n        position:absolute;\r\n        top: 3rem;\r\n        right: 1rem;\r\n        width: 38px;\r\n        height: 38px;\r\n        fill:$green;\r\n        transition: transform 0.25s ease;\r\n        cursor: pointer;\r\n        @include tablet{\r\n            right: 3rem;\r\n            width: 48px;\r\n            height: 48px;\r\n        }\r\n        &:hover{\r\n            transform: scale(1.1);\r\n            transform: transform 0.25s ease;\r\n        }\r\n    }\r\n}\r\n\r\n@keyframes fade-in{\r\n    from{transform :scale(0.5); opacity: 0;}\r\n    to{transform :scale(1); opacity: 1;}\r\n}\r\n\r\n/*EQUIPE*/\r\n\r\n.equipe{\r\n    display: flex;\r\n    flex-direction: column-reverse;\r\n    margin-top: 3rem;\r\n    padding: 0 2.5%;\r\n    gap: 2.5rem;\r\n    @include tablet{\r\n        gap:0;\r\n        margin-top: 10rem;\r\n        flex-direction: row;\r\n        padding: 0;\r\n    }\r\n    & .text{\r\n        flex: 0 0 38%;\r\n        & .persons{\r\n            display: flex;\r\n            flex-flow: row wrap;\r\n            gap: 1.5rem;\r\n            margin-top: 6rem;\r\n            @include tablet{\r\n                margin-top: inherit;\r\n                flex-flow: row wrap;\r\n            }\r\n            & .person{\r\n                display: flex;\r\n                align-items: center;\r\n                flex: 1 1 25%;\r\n                @include tablet{\r\n                }\r\n                & img{\r\n                    display: none;\r\n                    position: relative;\r\n                    width: 35%;\r\n                    aspect-ratio: 1/1;\r\n                    object-fit: cover;\r\n                    border-radius: 200px;\r\n                    border: 5px solid $white;\r\n                    z-index: 1;\r\n                    @include tablet{\r\n                        width: 8.594vw;\r\n                        height: 8.594vw;\r\n                    }\r\n                }\r\n                &>div{\r\n                    position: relative;\r\n                    display: flex;\r\n                    flex-direction: column;\r\n                    box-sizing: border-box;\r\n                    width:100%;\r\n                    padding: 4.667vw ;\r\n                    padding-left: 7.667vw ;\r\n                    background-color: $white;\r\n                    border-radius: 35px;\r\n                    color: $black;\r\n                    z-index: 0;\r\n                    text-align: center;\r\n                    @include tablet{\r\n                        min-width: 275px;\r\n                        padding: 1.667vw 2.333vw;\r\n                        border-radius: 50px;\r\n                        text-align: initial;\r\n                    }\r\n                    & a{\r\n                        font-size: clamp(12px, 0.8vw, 18px);\r\n                        line-height: 1.6;\r\n                        &:hover{\r\n                            color: $green;\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n    & .image{\r\n        position: relative;\r\n        flex: 1 1 auto;\r\n        margin-top: 3rem;\r\n        align-self: center;\r\n        @include tablet{\r\n            margin-top: 0;\r\n            margin-right: 2.5%;\r\n        }\r\n        & img{    \r\n            width: 100%;\r\n            height: 100%;\r\n            clip-path: url(\"#equipe-clip\") ;\r\n        }\r\n        & div{\r\n            z-index: 1;\r\n            position: absolute;\r\n            bottom: 5%;\r\n            left: 5%;\r\n            width: 35%;\r\n            @include tablet{\r\n                width: 20ch;\r\n                bottom: 9%;\r\n            }\r\n            & span{\r\n                font-size: clamp(25px, 3vw, 40px);\r\n                color: $green;\r\n            }\r\n            & p{\r\n                font-size: clamp(12px, 1vw, 20px);\r\n                margin-top: 0.5vw;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n/*FOOTER*/\r\n\r\nfooter{\r\n    position: relative;\r\n    display: flex;\r\n    flex-flow: column nowrap;\r\n    align-items: flex-end;\r\n    width: 100%;\r\n    height: auto;\r\n    margin: auto;\r\n    margin-top: 10rem;\r\n    @include tablet{\r\n        flex-flow: row nowrap;\r\n        width: 85%;\r\n        height: 21vw;\r\n        @include tablet-portrait{\r\n            width: 95%;\r\n            height: 23.883vh;\r\n        }\r\n    }\r\n    & .clip{\r\n        position: absolute;\r\n        top: 0;\r\n        left: 0;\r\n        width: 100%;\r\n        height: 100%;\r\n        background-color: $white;\r\n        border-radius: 80px 80px 0 0;\r\n        z-index: -1;\r\n        @include tablet{\r\n            border-radius: 0;\r\n            clip-path: url('#footer-clip');\r\n        }\r\n    }\r\n    & .content{\r\n        display: flex;\r\n        flex-flow: column wrap;\r\n        align-items: center;\r\n        justify-content: space-between;\r\n        width: 100%;\r\n        color: $black;\r\n        @include tablet{\r\n            flex-flow: row wrap;\r\n            padding: 0 8rem;\r\n            height: 68%;\r\n        }\r\n        @include tablet-portrait{\r\n            padding: 0 2rem;\r\n        }\r\n        & .contact-info{\r\n            display: flex;\r\n            flex-flow:  column wrap;\r\n            width: 90%;\r\n            align-items: baseline;\r\n            padding: 4rem 0;\r\n            gap: 3rem;\r\n            @include tablet{\r\n                flex-flow: row wrap;\r\n                width: 55%;\r\n                height: 58%;\r\n                padding: 0;\r\n                gap: inherit;\r\n            }\r\n            & .social-network{\r\n                width: 90%;\r\n                margin: auto;\r\n                @include tablet{\r\n                    width: auto;\r\n                    margin: inherit;\r\n                }\r\n                & .linkedin{\r\n                    display: block;\r\n                    width: 48px;\r\n                    height: 48px;\r\n                    display: flex;\r\n                    align-items: center;\r\n                    justify-content: center;\r\n                    background-color: $green;\r\n                    border-radius: 100px;\r\n                    border: 1px solid $green;\r\n                    @include tablet{\r\n                        width: 2.344vw;\r\n                        height: 2.344vw;\r\n                    }\r\n                    &:hover{\r\n                        background-color: transparent;\r\n                        & svg{\r\n                            fill: $green;\r\n                        }\r\n                    }\r\n                    & svg{\r\n                        fill: $white;\r\n                        height: 50%;\r\n                        width: 50%;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n        & h4{\r\n            text-transform: uppercase;\r\n            color: $black;\r\n            margin-bottom: 1rem;\r\n        }\r\n        & address{\r\n            display: flex;\r\n            flex-flow: row wrap;\r\n            align-items: center;\r\n            width: 90%;\r\n            margin: auto;\r\n            gap: 0.5rem;\r\n            font-style: normal;\r\n            @include tablet{\r\n                width: 60%;\r\n            }\r\n            & a{\r\n                font-size: clamp(12px, 0.8vw, 18px);\r\n                position: relative;\r\n                width: 100%;\r\n                padding-left: 2rem;\r\n                margin-bottom: 1rem;\r\n                line-height: 1.4;\r\n                &:hover{\r\n                    color: $green;\r\n                }\r\n            }\r\n            & svg{\r\n                position:absolute;\r\n                top: 50%;\r\n                transform:translateY(-50%) translateX(-2rem);\r\n                fill: $green;\r\n            }\r\n        }\r\n    }\r\n    & h2{\r\n        width: max-content;\r\n        margin: 3rem auto;\r\n        text-align: center;\r\n        color: $black;\r\n        @include tablet{\r\n            position: absolute;\r\n            top: 1.667vw;\r\n            left: 6.5vw;\r\n            margin: 0;\r\n            color: $white;\r\n        }\r\n        @include tablet-portrait{\r\n            top: 1.067vw;\r\n            left: 2.5vw;\r\n        }\r\n    }\r\n    & .logo{\r\n        height: 32vw;\r\n        max-height: 145px;\r\n        @include tablet{\r\n            height: 7.552vw;\r\n        }\r\n    }\r\n}\r\n\r\n.real{\r\n    width: 100%;\r\n    padding: 2rem 0;\r\n    & p{\r\n        text-align: center;\r\n        font-size: 14px;\r\n        & a:hover{\r\n            color: $green;\r\n        }\r\n    }\r\n}","$screen-sm-min: 375px; //0px to 375px\r\n$screen-sm-max: 900px; //900px to 1200px\r\n$screen-cp-min: 1200px; //1200px to xxx\r\n$screen-cp-max: 2560px; //1200px to xxx\r\n\r\n@mixin smartphoneMini {\r\n  @media\r\n  only screen and ( -webkit-max-device-pixel-ratio: 2) and  (max-width: #{$screen-sm-min} ),\r\n  only screen and ( max--moz-device-pixel-ratio: 1) and  (max-width: #{$screen-sm-min} ), \r\n  only screen and ( -o-max-device-pixel-ratio: 2 / 1) and  (max-width: #{$screen-sm-min} ),\r\n  only screen and ( max-device-pixel-ratio: 2) and  (max-width: #{$screen-sm-min} )\r\n  {\r\n      @content;\r\n  }\r\n}\r\n\r\n@mixin tablet {\r\n    @media\r\n    only screen and ( -webkit-max-device-pixel-ratio: 2.1) and  (min-width: #{$screen-sm-max} ),\r\n    only screen and ( max--moz-device-pixel-ratio: 2.1) and  (min-width: #{$screen-sm-max} ), \r\n    only screen and ( -o-max-device-pixel-ratio: 2.1 / 1) and  (min-width: #{$screen-sm-max} ),\r\n    only screen and ( max-device-pixel-ratio: 2.1) and  (min-width: #{$screen-sm-max} )\r\n        { \r\n        @content;\r\n    }\r\n}\r\n\r\n@mixin computer {\r\n  @media (min-width: #{$screen-cp-min}) {\r\n      @content;\r\n  }\r\n}\r\n\r\n@mixin big-desktop {\r\n    @media\r\n    only screen and ( -webkit-max-device-pixel-ratio: 2.1) and  (min-width: #{$screen-cp-max} ),\r\n    only screen and ( max--moz-device-pixel-ratio: 2.1) and  (min-width: #{$screen-cp-max} ), \r\n    only screen and ( -o-max-device-pixel-ratio: 2.1 / 1) and  (min-width: #{$screen-cp-max} ),\r\n    only screen and ( max-device-pixel-ratio: 2.1) and  (min-width: #{$screen-cp-max} )\r\n        { \r\n      @content;\r\n  }\r\n}\r\n\r\n@mixin smartphone-landscape {\r\n  @media only screen and (max-width: 1023px) and (orientation: landscape) {\r\n    @content;\r\n  }\r\n}\r\n\r\n@mixin tablet-portrait {\r\n  @media only screen and (min-width: 536px) and (orientation: portrait) {\r\n    @content;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
